import { Link_default } from "./chunk-LBI3C37W.js";
import { __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Link/LinkAsButton.tsx
import React, { forwardRef } from "react";
var LinkAsButton = forwardRef((props, ref) => /* @__PURE__ */React.createElement(Link_default, __spreadProps(__spreadValues({
  ref
}, props), {
  as: "button"
})));
var LinkAsButton_default = LinkAsButton;
export { LinkAsButton_default };